import { defineProperty as _defineProperty } from '../_virtual/_rollupPluginBabelHelpers.js';

var FEEDBACK_TYPES = {
  ERROR: 'error',
  INFO: 'info',
  SUCCESS: 'success',
  WARNING: 'warning'
};
var FEEDBACK_ICONS = _defineProperty(_defineProperty(_defineProperty(_defineProperty({}, FEEDBACK_TYPES.ERROR, 'CloseSolid'), FEEDBACK_TYPES.SUCCESS, 'Success'), FEEDBACK_TYPES.INFO, 'Info'), FEEDBACK_TYPES.WARNING, 'Warning');

export { FEEDBACK_ICONS, FEEDBACK_TYPES };
//# sourceMappingURL=feedback.js.map
